import { NETWORK_INFO } from '../constants/application.constants';

export const exclamation_triangle_filled = (className?: string) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      className={className ? className : `w-6 h-6`}
    >
      <path
        fillRule="evenodd"
        d="M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export const arrow_right_circle_filled = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    className="w-6 h-6"
  >
    <path
      fillRule="evenodd"
      d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm4.28 10.28a.75.75 0 000-1.06l-3-3a.75.75 0 10-1.06 1.06l1.72 1.72H8.25a.75.75 0 000 1.5h5.69l-1.72 1.72a.75.75 0 101.06 1.06l3-3z"
      clipRule="evenodd"
    />
  </svg>
);

export const arrow_left_circle_filled = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    className="w-6 h-6"
  >
    <path
      fillRule="evenodd"
      d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm-4.28 9.22a.75.75 0 000 1.06l3 3a.75.75 0 101.06-1.06l-1.72-1.72h5.69a.75.75 0 000-1.5h-5.69l1.72-1.72a.75.75 0 00-1.06-1.06l-3 3z"
      clipRule="evenodd"
    />
  </svg>
);

export const AngleCircle = (props: { direction: string }) => {
  if (props.direction && props.direction === 'left') {
    return (
      <svg
        className="mx-2"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="9"
          cy="9"
          r="9"
          transform="rotate(-180 9 9)"
          fill="#312E45"
        />
        <path
          d="M10.5 4.99835L6.49918 8.99918L10.5 13"
          stroke="white"
          strokeLinecap="round"
        />
      </svg>
    );
  } else {
    return (
      <svg
        className="mx-2"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="9" cy="9" r="9" fill="#312E45" />
        <path
          d="M7.5 13.0016L11.5008 9.00082L7.5 5"
          stroke="white"
          strokeLinecap="round"
        />
      </svg>
    );
  }
};

export const DoubleArrow = (props: any) => (
  <span className={props.classname}>
    <svg
      width="27"
      height="22"
      viewBox="0 0 27 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1_9)">
        <path d="M15.6807 19.5556H13.0807V22H15.6807V19.5556Z" fill="#312E45" />
        <path
          d="M18.2807 17.1111H15.6807V19.5556H18.2807V17.1111Z"
          fill="#312E45"
        />
        <path
          d="M20.8807 14.6667H18.2807V17.1111H20.8807V14.6667Z"
          fill="#312E45"
        />
        <path
          d="M23.4807 12.2222H20.8807V14.6667H23.4807V12.2222Z"
          fill="#312E45"
        />
        <path
          d="M26.0807 9.77778H23.4807V12.2222H26.0807V9.77778Z"
          fill="#312E45"
        />
        <path
          d="M23.4807 7.33333H20.8807V9.77778H23.4807V7.33333Z"
          fill="#312E45"
        />
        <path
          d="M20.8807 4.88889H18.2807V7.33333H20.8807V4.88889Z"
          fill="#312E45"
        />
        <path
          d="M18.2807 2.44444H15.6807V4.88889H18.2807V2.44444Z"
          fill="#312E45"
        />
        <path d="M15.6807 0H13.0807V2.44444H15.6807V0Z" fill="#312E45" />
      </g>
      <g clipPath="url(#clip1_1_9)">
        <path
          d="M2.68069 19.5556H0.0806885V22H2.68069V19.5556Z"
          fill="#312E45"
        />
        <path
          d="M5.28069 17.1111H2.68069V19.5556H5.28069V17.1111Z"
          fill="#312E45"
        />
        <path
          d="M7.88069 14.6667H5.28069V17.1111H7.88069V14.6667Z"
          fill="#312E45"
        />
        <path
          d="M10.4807 12.2222H7.88069V14.6667H10.4807V12.2222Z"
          fill="#312E45"
        />
        <path
          d="M13.0807 9.77778H10.4807V12.2222H13.0807V9.77778Z"
          fill="#312E45"
        />
        <path
          d="M10.4807 7.33333H7.88069V9.77778H10.4807V7.33333Z"
          fill="#312E45"
        />
        <path
          d="M7.88069 4.88889H5.28069V7.33333H7.88069V4.88889Z"
          fill="#312E45"
        />
        <path
          d="M5.28069 2.44444H2.68069V4.88889H5.28069V2.44444Z"
          fill="#312E45"
        />
        <path d="M2.68069 0H0.0806885V2.44444H2.68069V0Z" fill="#312E45" />
      </g>
      <defs>
        <clipPath id="clip0_1_9">
          <rect
            width="13"
            height="22"
            fill="white"
            transform="translate(13.0807)"
          />
        </clipPath>
        <clipPath id="clip1_1_9">
          <rect
            width="13"
            height="22"
            fill="white"
            transform="translate(0.0806885)"
          />
        </clipPath>
      </defs>
    </svg>
  </span>
);

export const NetworkLogo = (props: {
  chainId: string;
  direction: string;
  className?: string | undefined;
}) => {
  const networkInfo = NETWORK_INFO[props.chainId];

  if (networkInfo) {
    return <div className={props.className}>{networkInfo.icon}</div>;
  } else {
    return <AngleCircle direction={props.direction} />;
  }
};

export const CheckmarkIcon = (
  <svg
    style={{ display: 'inline' }}
    width="85"
    height="85"
    viewBox="0 0 85 85"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="42.5" cy="42.5" r="42.5" fill="#E1CFFF" />
    <path
      d="M23.3767 44.3821L36.3694 57.375L61.6265 31.875"
      stroke="#312E45"
      strokeWidth="3"
      strokeLinecap="round"
    />
  </svg>
);

export const CopyIcon = (
  <svg
    style={{ display: 'inline' }}
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="8.5" cy="8.5" r="8.5" fill="#E1CFFF" />
    <path
      d="M5.5 13C5.225 13 4.9895 12.9022 4.7935 12.7065C4.59783 12.5105 4.5 12.275 4.5 12V5H5.5V12H11V13H5.5ZM7.5 11C7.225 11 6.98967 10.9022 6.794 10.7065C6.598 10.5105 6.5 10.275 6.5 10V4C6.5 3.725 6.598 3.4895 6.794 3.2935C6.98967 3.09783 7.225 3 7.5 3H12C12.275 3 12.5105 3.09783 12.7065 3.2935C12.9022 3.4895 13 3.725 13 4V10C13 10.275 12.9022 10.5105 12.7065 10.7065C12.5105 10.9022 12.275 11 12 11H7.5Z"
      fill="#312E45"
    />
  </svg>
);

/* 
                                              ----ERROR ICONS----
*/

export const GeneralSimulationError = (
  <svg
    style={{ display: 'inline' }}
    width="43"
    height="43"
    viewBox="0 0 43 43"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.4573 2L2 13.4573V29.543L13.4573 41.0002H29.543L41.0002 29.543V13.4573L29.543 2H13.4573Z"
      stroke="#312E45"
      strokeWidth="2.5"
      strokeMiterlimit="10"
    />
    <path
      d="M21.5 11.1945V25.0039"
      stroke="#312E45"
      strokeWidth="2.5"
      strokeMiterlimit="10"
    />
    <path
      d="M21.5 31C22.3284 31 23 30.3284 23 29.5C23 28.6716 22.3284 28 21.5 28C20.6716 28 20 28.6716 20 29.5C20 30.3284 20.6716 31 21.5 31Z"
      fill="#312E45"
      stroke="#312E45"
      strokeWidth="0.5"
      strokeMiterlimit="10"
    />
  </svg>
);

export const OutOfGasError = (
  <svg
    style={{ display: 'inline' }}
    width="35"
    height="44"
    viewBox="0 0 35 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.7488 2C17.7488 2 33.4975 17.7892 33.4975 26.3778C33.4975 34.9665 26.459 41.9068 17.7488 41.9068C9.03855 41.9068 2 34.9665 2 26.3778C2 17.7892 17.7488 2 17.7488 2Z"
      stroke="#312E45"
      strokeWidth="2.5"
      strokeMiterlimit="10"
    />
    <path
      d="M7.01489 26.6381C7.01489 32.4506 11.8539 37.2221 17.7487 37.2221"
      stroke="#312E45"
      strokeWidth="2.5"
      strokeMiterlimit="10"
    />
  </svg>
);

export const InsufficientGasLimitError = (
  <svg
    style={{ display: 'inline' }}
    width="46"
    height="44"
    viewBox="0 0 46 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 8.03345H6.32685L12.356 33H33.8672L36.919 20.8454"
      stroke="#312E45"
      strokeWidth="2.5"
      strokeMiterlimit="10"
    />
    <path
      d="M7.66699 13.5457H25.01"
      stroke="#312E45"
      strokeWidth="2.5"
      strokeMiterlimit="10"
    />
    <path
      d="M34.3888 21.0689C39.6507 21.0689 43.9163 16.8002 43.9163 11.5345C43.9163 6.26872 39.6507 2 34.3888 2C29.1269 2 24.8613 6.26872 24.8613 11.5345C24.8613 16.8002 29.1269 21.0689 34.3888 21.0689Z"
      stroke="#312E45"
      strokeWidth="2.5"
      strokeMiterlimit="10"
    />
    <path
      d="M14.1423 42.0002C15.5811 42.0002 16.7475 40.8329 16.7475 39.3931C16.7475 37.9532 15.5811 36.786 14.1423 36.786C12.7035 36.786 11.5371 37.9532 11.5371 39.3931C11.5371 40.8329 12.7035 42.0002 14.1423 42.0002Z"
      stroke="#312E45"
      strokeWidth="2.5"
      strokeMiterlimit="10"
    />
    <path
      d="M32.3044 42.0002C33.7432 42.0002 34.9096 40.8329 34.9096 39.3931C34.9096 37.9532 33.7432 36.786 32.3044 36.786C30.8656 36.786 29.6992 37.9532 29.6992 39.3931C29.6992 40.8329 30.8656 42.0002 32.3044 42.0002Z"
      stroke="#312E45"
      strokeWidth="2.5"
      strokeMiterlimit="10"
    />
    <path
      d="M34.3882 6V12.4804"
      stroke="#312E45"
      strokeWidth="2.5"
      strokeMiterlimit="10"
    />
    <path
      d="M34.3883 17C35.246 17 35.9412 16.3042 35.9412 15.446C35.9412 14.5877 35.246 13.892 34.3883 13.892C33.5307 13.892 32.8354 14.5877 32.8354 15.446C32.8354 16.3042 33.5307 17 34.3883 17Z"
      fill="#312E45"
    />
  </svg>
);

export const RateLimited = (
  <svg
    style={{ display: 'inline' }}
    width="43"
    height="43"
    viewBox="0 0 43 43"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.4785 0C9.6105 0 0 9.632 0 21.5C0 33.368 9.6105 43 21.4785 43C33.368 43 43 33.368 43 21.5C43 9.632 33.368 0 21.4785 0ZM21.5 38.7C11.997 38.7 4.3 31.003 4.3 21.5C4.3 11.997 11.997 4.3 21.5 4.3C31.003 4.3 38.7 11.997 38.7 21.5C38.7 31.003 31.003 38.7 21.5 38.7Z"
      fill="#312E45"
    />
    <path
      d="M22.5751 10.75H19.3501V23.65L30.6376 30.4225L32.2501 27.778L22.5751 22.0375V10.75Z"
      fill="#312E45"
    />
  </svg>
);

export const NotVerified = (
  <svg
    style={{ display: 'inline' }}
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M36.0417 19.9167H37.8333M31.5625 6.47917L30.6667 7.375M2 19.9167H3.79167M19.9167 2V3.79167M7.24779 7.24779L8.5145 8.5145M19.9167 19.9167V30.6667M10.9583 19.9167C10.9583 17.5408 11.9022 15.2622 13.5822 13.5822C15.2622 11.9022 17.5408 10.9583 19.9167 10.9583V10.9583C22.2926 10.9583 24.5712 11.9022 26.2512 13.5822C27.9312 15.2622 28.875 17.5408 28.875 19.9167V30.6667H10.9583V19.9167ZM7.375 34.25C7.375 33.2996 7.75253 32.3882 8.42453 31.7162C9.09654 31.0442 10.008 30.6667 10.9583 30.6667H28.875C29.8254 30.6667 30.7368 31.0442 31.4088 31.7162C32.0808 32.3882 32.4583 33.2996 32.4583 34.25V37.8333H7.375V34.25Z"
      stroke="#312E45"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const InsufficientFunds = (
  <svg
    style={{ display: 'inline' }}
    width="51"
    height="51"
    viewBox="0 0 51 51"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_695_10087)">
      <circle
        cx="25.5"
        cy="21.5"
        r="20.25"
        stroke="#312E45"
        strokeWidth="2.5"
      />
      <line
        x1="11.1766"
        y1="7.50638"
        x2="39.4937"
        y2="35.8234"
        stroke="#312E45"
        strokeWidth="2.5"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_695_10087"
        x="0"
        y="0"
        width="51"
        height="51"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_695_10087"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_695_10087"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const FireIcon = (
  <svg
    style={{ display: 'inline' }}
    width="44"
    height="58"
    viewBox="0 0 44 58"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.1804 51.5947H10.7871V57.3276H16.1804V51.5947Z"
      fill="#CD2E36"
    />
    <path
      d="M21.5721 51.5947H16.1787V57.3276H21.5721V51.5947Z"
      fill="#CD2E36"
    />
    <path d="M26.965 51.5947H21.5718V57.3276H26.965V51.5947Z" fill="#CD2E36" />
    <path
      d="M32.3603 51.5947H26.9668V57.3276H32.3603V51.5947Z"
      fill="#CD2E36"
    />
    <path
      d="M10.7864 45.8638H5.39307V51.5964H10.7864V45.8638Z"
      fill="#CD2E36"
    />
    <path
      d="M16.1804 45.8638H10.7871V51.5964H16.1804V45.8638Z"
      fill="#F19324"
    />
    <path d="M21.5721 45.8638H16.1787V51.5964H21.5721V45.8638Z" fill="white" />
    <path d="M26.965 45.8638H21.5718V51.5964H26.965V45.8638Z" fill="white" />
    <path
      d="M32.3603 45.8638H26.9668V51.5964H32.3603V45.8638Z"
      fill="#F19324"
    />
    <path
      d="M37.7512 45.8638H32.3579V51.5964H37.7512V45.8638Z"
      fill="#CD2E36"
    />
    <path d="M5.39332 40.1289H0V45.8617H5.39332V40.1289Z" fill="#CD2E36" />
    <path
      d="M10.7864 40.1289H5.39307V45.8617H10.7864V40.1289Z"
      fill="#F19324"
    />
    <path d="M16.1804 40.1289H10.7871V45.8617H16.1804V40.1289Z" fill="white" />
    <path d="M21.5721 40.1289H16.1787V45.8617H21.5721V40.1289Z" fill="white" />
    <path d="M26.965 40.1289H21.5718V45.8617H26.965V40.1289Z" fill="white" />
    <path d="M32.3603 40.1289H26.9668V45.8617H32.3603V40.1289Z" fill="white" />
    <path
      d="M37.7512 40.1289H32.3579V45.8617H37.7512V40.1289Z"
      fill="#F19324"
    />
    <path
      d="M43.1459 40.1289H37.7524V45.8617H43.1459V40.1289Z"
      fill="#CD2E36"
    />
    <path d="M5.39332 34.3975H0V40.1303H5.39332V34.3975Z" fill="#CD2E36" />
    <path
      d="M10.7864 34.3975H5.39307V40.1303H10.7864V34.3975Z"
      fill="#F19324"
    />
    <path
      d="M16.1804 34.3975H10.7871V40.1303H16.1804V34.3975Z"
      fill="#FFB930"
    />
    <path d="M21.5721 34.3975H16.1787V40.1303H21.5721V34.3975Z" fill="white" />
    <path d="M26.965 34.3975H21.5718V40.1303H26.965V34.3975Z" fill="white" />
    <path
      d="M32.3603 34.3975H26.9668V40.1303H32.3603V34.3975Z"
      fill="#FFB930"
    />
    <path
      d="M37.7512 34.3975H32.3579V40.1303H37.7512V34.3975Z"
      fill="#F19324"
    />
    <path
      d="M43.1459 34.3975H37.7524V40.1303H43.1459V34.3975Z"
      fill="#CD2E36"
    />
    <path d="M10.7864 28.665H5.39307V34.3977H10.7864V28.665Z" fill="#CD2E36" />
    <path d="M16.1804 28.665H10.7871V34.3977H16.1804V28.665Z" fill="#F19324" />
    <path d="M21.5721 28.665H16.1787V34.3977H21.5721V28.665Z" fill="#FFB930" />
    <path d="M26.965 28.665H21.5718V34.3977H26.965V28.665Z" fill="white" />
    <path d="M32.3603 28.665H26.9668V34.3977H32.3603V28.665Z" fill="#F19324" />
    <path d="M37.7512 28.665H32.3579V34.3977H37.7512V28.665Z" fill="#CD2E36" />
    <path
      d="M16.1804 22.9316H10.7871V28.6645H16.1804V22.9316Z"
      fill="#CD2E36"
    />
    <path
      d="M21.5721 22.9316H16.1787V28.6645H21.5721V22.9316Z"
      fill="#F19324"
    />
    <path d="M26.965 22.9316H21.5718V28.6645H26.965V22.9316Z" fill="#FFB930" />
    <path
      d="M32.3603 22.9316H26.9668V28.6645H32.3603V22.9316Z"
      fill="#FFB930"
    />
    <path
      d="M37.7512 22.9316H32.3579V28.6645H37.7512V22.9316Z"
      fill="#CD2E36"
    />
    <path d="M16.1804 17.1992H10.7871V22.932H16.1804V17.1992Z" fill="#CD2E36" />
    <path d="M21.5721 17.1992H16.1787V22.932H21.5721V17.1992Z" fill="#F19324" />
    <path d="M26.965 17.1992H21.5718V22.932H26.965V17.1992Z" fill="#CD2E36" />
    <path d="M32.3603 17.1992H26.9668V22.932H32.3603V17.1992Z" fill="#FFB930" />
    <path d="M37.7512 17.1992H32.3579V22.932H37.7512V17.1992Z" fill="#FFB930" />
    <path d="M43.1459 17.1992H37.7524V22.932H43.1459V17.1992Z" fill="#CD2E36" />
    <path
      d="M10.7864 11.4653H5.39307V17.1981H10.7864V11.4653Z"
      fill="#CD2E36"
    />
    <path
      d="M16.1804 11.4653H10.7871V17.1981H16.1804V11.4653Z"
      fill="#F19324"
    />
    <path
      d="M21.5721 11.4653H16.1787V17.1981H21.5721V11.4653Z"
      fill="#CD2E36"
    />
    <path
      d="M32.3603 11.4653H26.9668V17.1981H32.3603V11.4653Z"
      fill="#FFB930"
    />
    <path
      d="M37.7512 11.4653H32.3579V17.1981H37.7512V11.4653Z"
      fill="#CD2E36"
    />
    <path d="M10.7864 5.7334H5.39307V11.4661H10.7864V5.7334Z" fill="#CD2E36" />
    <path d="M16.1804 5.7334H10.7871V11.4661H16.1804V5.7334Z" fill="#FFB930" />
    <path d="M21.5721 5.7334H16.1787V11.4661H21.5721V5.7334Z" fill="#CD2E36" />
    <path d="M32.3603 5.7334H26.9668V11.4661H32.3603V5.7334Z" fill="#CD2E36" />
    <path d="M16.1804 0H10.7871V5.73275H16.1804V0Z" fill="#CD2E36" />
  </svg>
);

export const ShareIcon = (fillColor: string) => {
  return (
    <svg
      style={{ display: 'inline' }}
      width="23"
      height="21"
      viewBox="0 0 23 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_890_2013)">
        <path
          d="M19.4615 13.5215V17.0625C19.4615 18.1471 19.0722 19.0745 18.2936 19.8447C17.5149 20.6149 16.5773 21 15.4808 21H3.98077C2.88421 21 1.94661 20.6149 1.16797 19.8447C0.389323 19.0745 0 18.1471 0 17.0625V5.6875C0 4.60286 0.389323 3.67546 1.16797 2.90527C1.94661 2.13509 2.88421 1.75 3.98077 1.75H7.50541C7.6252 1.75 7.72887 1.79329 7.81641 1.87988C7.90395 1.96647 7.94772 2.06901 7.94772 2.1875C7.94772 2.43359 7.82792 2.57943 7.58834 2.625C6.87881 2.86198 6.26603 3.13542 5.75 3.44531C5.65785 3.48177 5.58413 3.5 5.52885 3.5H3.98077C3.3726 3.5 2.85196 3.71419 2.41887 4.14258C1.98578 4.57096 1.76923 5.08594 1.76923 5.6875V17.0625C1.76923 17.6641 1.98578 18.179 2.41887 18.6074C2.85196 19.0358 3.3726 19.25 3.98077 19.25H15.4808C16.0889 19.25 16.6096 19.0358 17.0427 18.6074C17.4758 18.179 17.6923 17.6641 17.6923 17.0625V14.1367C17.6923 13.9635 17.7752 13.8314 17.9411 13.7402C18.1991 13.6217 18.4479 13.4531 18.6875 13.2344C18.8349 13.0885 18.9962 13.0521 19.1713 13.125C19.3648 13.207 19.4615 13.3392 19.4615 13.5215ZM22.7374 6.74023L17.4297 11.9902C17.2638 12.1634 17.0565 12.25 16.8077 12.25C16.6971 12.25 16.5819 12.2272 16.4621 12.1816C16.1028 12.0267 15.9231 11.7578 15.9231 11.375V8.75H13.7115C10.7352 8.75 8.71715 9.347 7.65745 10.541C6.5609 11.7897 6.21995 13.9453 6.63462 17.0078C6.66226 17.2174 6.57011 17.3724 6.35817 17.4727C6.28445 17.4909 6.22917 17.5 6.19231 17.5C6.04487 17.5 5.92508 17.4408 5.83293 17.3223C5.74079 17.1947 5.64403 17.0534 5.54267 16.8984C5.44131 16.7435 5.25931 16.4313 4.99669 15.9619C4.73407 15.4925 4.50601 15.0391 4.3125 14.6016C4.11899 14.1641 3.94161 13.6445 3.78035 13.043C3.61909 12.4414 3.53846 11.8854 3.53846 11.375C3.53846 10.9284 3.55459 10.5137 3.58684 10.1309C3.61909 9.74805 3.68359 9.33789 3.78035 8.90039C3.8771 8.46289 4.00611 8.06185 4.16737 7.69727C4.32863 7.33268 4.54517 6.96126 4.81701 6.58301C5.08884 6.20475 5.40445 5.86751 5.76382 5.57129C6.1232 5.27506 6.55859 4.99479 7.07001 4.73047C7.58143 4.46615 8.15505 4.24512 8.79086 4.06738C9.42668 3.88965 10.1616 3.75065 10.9955 3.65039C11.8294 3.55013 12.7348 3.5 13.7115 3.5H15.9231V0.875C15.9231 0.492188 16.1028 0.223307 16.4621 0.0683594C16.5819 0.0227865 16.6971 0 16.8077 0C17.0473 0 17.2546 0.0865885 17.4297 0.259766L22.7374 5.50977C22.9125 5.68294 23 5.88802 23 6.125C23 6.36198 22.9125 6.56706 22.7374 6.74023Z"
          fill={fillColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_890_2013">
          <rect width="23" height="21" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ShareToTwitterIcon = (
  <svg
    style={{ display: 'inline' }}
    width="85"
    height="85"
    viewBox="0 0 85 85"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="42.5" cy="42.5" r="42.5" fill="#E1CFFF" />
    <path
      d="M33.813 40.111C34.2664 39.2042 34.736 38.3298 35.2218 37.4878C35.7075 36.6457 36.2419 35.8037 36.8249 34.9616L34.1044 34.4273L30.0238 38.5079L33.813 40.111ZM57.228 26.7518C54.961 26.8166 52.5405 27.4805 49.9665 28.7435C47.3911 30.0066 45.0509 31.6907 42.9458 33.7958C41.5856 35.156 40.3711 36.6133 39.3024 38.1679C38.2337 39.7224 37.4402 41.1798 36.922 42.54L42.46 48.0294C43.8202 47.5112 45.2776 46.7178 46.8321 45.649C48.3867 44.5803 49.844 43.3658 51.2042 42.0056C53.3093 39.9005 54.9934 37.5687 56.2565 35.0102C57.5195 32.4517 58.1834 30.039 58.2482 27.772C58.2482 27.6424 58.2242 27.5129 58.1763 27.3833C58.1271 27.2538 58.0539 27.1404 57.9567 27.0433C57.8596 26.9461 57.7462 26.8729 57.6167 26.8237C57.4871 26.7758 57.3576 26.7518 57.228 26.7518V26.7518ZM46.5407 38.4108C45.7958 37.6659 45.4233 36.7507 45.4233 35.6651C45.4233 34.5808 45.7958 33.6662 46.5407 32.9213C47.2855 32.1765 48.2085 31.804 49.3097 31.804C50.4108 31.804 51.3338 32.1765 52.0787 32.9213C52.8235 33.6662 53.196 34.5808 53.196 35.6651C53.196 36.7507 52.8235 37.6659 52.0787 38.4108C51.3338 39.1556 50.4108 39.5281 49.3097 39.5281C48.2085 39.5281 47.2855 39.1556 46.5407 38.4108ZM44.889 51.1385L46.4921 54.9762L50.5727 50.8956L50.0383 48.1751C49.1963 48.7581 48.3543 49.284 47.5122 49.753C46.6702 50.2232 45.7958 50.6851 44.889 51.1385ZM61.9402 25.1973C62.1993 28.7597 61.6163 32.2328 60.1914 35.6165C58.7664 39.0015 56.5156 42.2323 53.4389 45.309L54.4105 50.1183C54.54 50.766 54.5076 51.3975 54.3133 52.0129C54.119 52.6282 53.7951 53.1626 53.3417 53.616L47.2208 59.7369C46.735 60.2227 46.152 60.4086 45.4719 60.2946C44.7918 60.1819 44.3222 59.8017 44.0631 59.154L41.0998 52.2072L32.7928 43.9002L25.846 40.9369C25.1983 40.6778 24.8097 40.2082 24.6801 39.5281C24.5506 38.848 24.7287 38.265 25.2145 37.7792L31.3354 31.6583C31.7888 31.2049 32.3316 30.881 32.9638 30.6867C33.5947 30.4924 34.234 30.46 34.8817 30.5895L39.691 31.5611C42.7677 28.4844 45.9985 26.2336 49.3835 24.8086C52.7672 23.3836 56.2403 22.8007 59.8027 23.0598C60.0618 23.0922 60.3209 23.1647 60.58 23.2774C60.8391 23.3914 61.0658 23.5456 61.2601 23.7399C61.4544 23.9342 61.6079 24.1609 61.7206 24.42C61.8346 24.6791 61.9078 24.9382 61.9402 25.1973V25.1973ZM27.6434 49.0981C28.7769 47.9646 30.1611 47.3895 31.796 47.3726C33.4321 47.3571 34.8169 47.9161 35.9504 49.0496C37.0839 50.1831 37.6423 51.5672 37.6254 53.2021C37.6099 54.8382 37.0354 56.2231 35.9019 57.3566C35.0922 58.1662 33.7404 58.8625 31.8465 59.4455C29.9513 60.0284 27.3358 60.5466 24 61C24.4534 57.6642 24.9716 55.0487 25.5545 53.1535C26.1375 51.2596 26.8338 49.9078 27.6434 49.0981V49.0981ZM30.4124 51.8186C30.0886 52.1424 29.7647 52.7338 29.4408 53.5927C29.117 54.4503 28.8903 55.3163 28.7607 56.1907C29.6352 56.0611 30.5018 55.8428 31.3607 55.5358C32.2183 55.2275 32.809 54.9114 33.1329 54.5876C33.5215 54.1989 33.732 53.7293 33.7644 53.1788C33.7968 52.6282 33.6186 52.1586 33.23 51.77C32.8414 51.3814 32.3718 51.1948 31.8212 51.2104C31.2707 51.2272 30.8011 51.4299 30.4124 51.8186V51.8186Z"
      fill="#312E45"
    />
  </svg>
);

export const DangerIcon = (
  <svg
    style={{ display: 'inline' }}
    width="41"
    height="35"
    viewBox="0 0 41 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.791687 34.6249L20.5 0.583252L40.2084 34.6249H0.791687ZM6.97294 31.0416H34.0271L20.5 7.74992L6.97294 31.0416ZM20.5 29.2499C21.0077 29.2499 21.4335 29.0779 21.7775 28.7339C22.1203 28.3911 22.2917 27.9659 22.2917 27.4583C22.2917 26.9506 22.1203 26.5254 21.7775 26.1826C21.4335 25.8386 21.0077 25.6666 20.5 25.6666C19.9924 25.6666 19.5672 25.8386 19.2244 26.1826C18.8804 26.5254 18.7084 26.9506 18.7084 27.4583C18.7084 27.9659 18.8804 28.3911 19.2244 28.7339C19.5672 29.0779 19.9924 29.2499 20.5 29.2499ZM18.7084 23.8749H22.2917V14.9166H18.7084V23.8749Z"
      fill="#312E45"
    />
  </svg>
);

export const BackArrow = (
  <svg
    style={{ display: 'inline' }}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 16L0 8L8 0L9.425 1.4L3.825 7H16V9H3.825L9.425 14.6L8 16Z"
      fill="#312E45"
    />
  </svg>
);

export const verifiedIcon = (
  <svg
    width="12"
    style={{ display: 'inline' }}
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="12" height="12" rx="6" fill="#12B76A" />
    <path
      d="M3.27271 6.0727L5.09089 7.89088L8.72725 4.25452"
      stroke="white"
      strokeWidth="1.1"
    />
  </svg>
);

export const SafetyShield = ({ isSafe }: any) => {
  return (
    <svg
      style={{ display: 'inline' }}
      width="33"
      height="37"
      viewBox="0 0 33 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.2423 0.932719C15.9491 0.667592 16.7216 0.632478 17.4496 0.832386L17.7577 0.932719L30.2994 5.63584C30.9351 5.87417 31.49 6.28816 31.8994 6.82961C32.3089 7.37106 32.5562 8.01769 32.6125 8.69422L32.625 8.99164V18.6003C32.6246 21.5033 31.8406 24.3523 30.3556 26.8467C28.8706 29.3411 26.7398 31.3884 24.188 32.7724L23.7115 33.0233L17.7022 36.0261C17.3715 36.1916 17.0101 36.287 16.6408 36.3064C16.2714 36.3259 15.9021 36.2689 15.5558 36.139L15.2978 36.0261L9.28854 33.0215C6.69172 31.723 4.49364 29.7475 2.92634 27.3036C1.35904 24.8596 0.480673 22.0378 0.383959 19.1361L0.375 18.5986V8.99343C0.37501 8.31462 0.567831 7.64977 0.931015 7.07629C1.2942 6.50281 1.8128 6.04429 2.42646 5.75409L2.70058 5.63764L15.2423 0.934511V0.932719ZM14.9645 11.6057L11.3973 17.5504C11.2324 17.825 11.1433 18.1385 11.1392 18.4588C11.1351 18.7791 11.2161 19.0947 11.3738 19.3735C11.5316 19.6522 11.7606 19.8841 12.0373 20.0454C12.314 20.2067 12.6286 20.2917 12.9489 20.2917H16.9193L14.9645 23.5507C14.7363 23.9572 14.6754 24.4366 14.7949 24.8872C14.9144 25.3379 15.2049 25.7241 15.6045 25.9641C16.0042 26.204 16.4817 26.2788 16.9356 26.1724C17.3895 26.066 17.784 25.7869 18.0355 25.3943L21.6027 19.4496C21.7676 19.175 21.8567 18.8615 21.8608 18.5413C21.8649 18.221 21.7839 17.9053 21.6262 17.6266C21.4684 17.3478 21.2394 17.1159 20.9627 16.9546C20.686 16.7933 20.3714 16.7083 20.0511 16.7083H16.0807L18.0355 13.4493C18.2637 13.0428 18.3246 12.5634 18.2051 12.1128C18.0856 11.6622 17.7951 11.2759 17.3955 11.0359C16.9958 10.796 16.5183 10.7213 16.0644 10.8276C15.6105 10.934 15.216 11.2131 14.9645 11.6057Z"
        fill={isSafe ? 'white' : '#312E45'}
      />
    </svg>
  );
};

export const EyeIcon = (
  <svg
    style={{ display: 'inline' }}
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="20" cy="20" r="20" fill="#312E45" />
    <path
      d="M20 27.7917C24.5563 27.7917 28.25 23.9774 28.25 21.375C28.25 18.7726 24.5563 14.9583 20 14.9583C15.4437 14.9583 11.75 18.7753 11.75 21.375C11.75 23.9747 15.4437 27.7917 20 27.7917Z"
      stroke="white"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M20 24.125C20.7293 24.125 21.4288 23.8353 21.9445 23.3195C22.4603 22.8038 22.75 22.1043 22.75 21.375C22.75 20.6456 22.4603 19.9462 21.9445 19.4304C21.4288 18.9147 20.7293 18.625 20 18.625C19.2707 18.625 18.5712 18.9147 18.0555 19.4304C17.5397 19.9462 17.25 20.6456 17.25 21.375C17.25 22.1043 17.5397 22.8038 18.0555 23.3195C18.5712 23.8353 19.2707 24.125 20 24.125Z"
      stroke="white"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M15.0791 14.1636L16.268 15.8227M25.3279 14.3671L24.1385 16.0262M20.0039 12.2083V14.9583"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const StopIcon = (
  <svg
    style={{ display: 'inline' }}
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="20" cy="20" r="20" fill="#312E45" />
    <path
      d="M20.0002 10.8334C14.9585 10.8334 10.8335 14.9584 10.8335 20C10.8335 25.0417 14.9585 29.1667 20.0002 29.1667C25.0418 29.1667 29.1668 25.0417 29.1668 20C29.1668 14.9584 25.0418 10.8334 20.0002 10.8334ZM12.6668 20C12.6668 15.9667 15.9668 12.6667 20.0002 12.6667C21.6502 12.6667 23.2085 13.2167 24.4918 14.225L14.2252 24.4917C13.2168 23.2084 12.6668 21.65 12.6668 20ZM20.0002 27.3334C18.3502 27.3334 16.7918 26.7834 15.5085 25.775L25.7752 15.5084C26.7835 16.7917 27.3335 18.35 27.3335 20C27.3335 24.0334 24.0335 27.3334 20.0002 27.3334Z"
      fill="white"
    />
  </svg>
);

export const QuestionIcon = (
  <svg
    style={{ display: 'inline' }}
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="25" cy="25" r="25" fill="#312E45" />
    <g clipPath="url(#clip0_1790_3566)">
      <path
        d="M23.146 29.3333C23.146 27.7865 23.2846 26.6739 23.5619 25.9955C23.8385 25.318 24.4255 24.5781 25.3231 23.776C26.1061 23.0885 26.7027 22.4916 27.1129 21.9851C27.5238 21.4794 27.7293 20.9019 27.7293 20.2526C27.7293 19.4696 27.4669 18.8203 26.9421 18.3047C26.4166 17.7891 25.6859 17.5312 24.7502 17.5312C23.7762 17.5312 23.036 17.8273 22.5295 18.4193C22.0238 19.0113 21.666 19.6128 21.4559 20.224L18.5054 18.9635C18.9064 17.7413 19.6417 16.6814 20.7111 15.7839C21.7805 14.8863 23.1269 14.4375 24.7502 14.4375C26.7554 14.4375 28.2977 14.9963 29.377 16.1139C30.4556 17.2307 30.995 18.572 30.995 20.138C30.995 21.0929 30.7899 21.9095 30.3796 22.5878C29.9687 23.2654 29.3239 24.0339 28.4455 24.8932C27.5097 25.7908 26.9418 26.4733 26.7416 26.9408C26.5407 27.4091 26.4403 28.2066 26.4403 29.3333H23.146ZM24.7502 36.2083C24.12 36.2083 23.5806 35.9841 23.1322 35.5357C22.6831 35.0866 22.4585 34.5469 22.4585 33.9167C22.4585 33.2865 22.6831 32.7468 23.1322 32.2976C23.5806 31.8492 24.12 31.625 24.7502 31.625C25.3804 31.625 25.9201 31.8492 26.3692 32.2976C26.8176 32.7468 27.0418 33.2865 27.0418 33.9167C27.0418 34.5469 26.8176 35.0866 26.3692 35.5357C25.9201 35.9841 25.3804 36.2083 24.7502 36.2083Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_1790_3566">
        <rect
          width="27.5"
          height="27.5"
          fill="white"
          transform="translate(11.25 11.25)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const WarningIcon = (
  <svg
    style={{ display: 'inline' }}
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="25" cy="25" r="25" fill="#312E45" />
    <g clipPath="url(#clip0_1790_3575)">
      <path
        d="M24.7502 13.8646L12.146 35.6354H37.3543L24.7502 13.8646Z"
        stroke="white"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M24.75 31.0521V31.625M24.75 21.8854L24.7546 27.6146"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1790_3575">
        <rect
          width="27.5"
          height="27.5"
          fill="white"
          transform="translate(11 11)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const RightCarat = (
  <svg
    className="mt-[2px]"
    width="8"
    height="14"
    viewBox="0 0 8 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 12.4854L6.65685 6.8285L0.999999 1.17164"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const VerifiedDomain = (
  <svg
    width="11"
    height="11"
    viewBox="0 0 11 11"
    style={{ display: 'inline' }}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="11" height="11" rx="5.5" fill="#FEAD2D" />
    <path
      d="M3 5.56669L4.66667 7.23336L8 3.90002"
      stroke="white"
      strokeWidth="1.1"
    />
  </svg>
);

export const signatureIcon = (
  <svg
    width="38"
    height="38"
    viewBox="0 0 38 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="19" cy="19" r="19" fill="white" />
    <path
      d="M28.7 19.9L23 25.6H20.7V23.3L26.4 17.6L28.7 19.9ZM32.1 19.1C32.1 19.4 31.8 19.7 31.5 20L29 22.5L28.1 21.6L30.7 19L30.1 18.4L29.4 19.1L27.1 16.8L29.3 14.7C29.5 14.5 29.9 14.5 30.2 14.7L31.6 16.1C31.8 16.3 31.8 16.7 31.6 17C31.4 17.2 31.2 17.4 31.2 17.6C31.2 17.8 31.4 18 31.6 18.2C31.9 18.5 32.2 18.8 32.1 19.1ZM12 27V11H19V16H24V17.5L26 15.5V15L20 9H12C10.9 9 10 9.9 10 11V27C10 28.1 10.9 29 12 29H24C25.1 29 26 28.1 26 27H12ZM20 24.1C19.8 24.1 19.6 24.2 19.5 24.2L19 22H17.5L15.4 23.7L16 21H14.5L13.5 26H15L17.9 23.4L18.5 25.7H19.5L20 25.6V24.1Z"
      fill="#312E45"
    />
  </svg>
);

export const defaultApprovalIcon = (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="32" height="32" rx="16" fill="#312E45" />
    <path
      d="M12 15H20V17H12V15ZM14 23H10V7H17V12H22V15.1L24 13.1V11L18 5H10C9.46957 5 8.96086 5.21071 8.58579 5.58579C8.21071 5.96086 8 6.46957 8 7V23C8 23.5304 8.21071 24.0391 8.58579 24.4142C8.96086 24.7893 9.46957 25 10 25H14V23ZM12 21H16.1L17 20.1V19H12V21ZM24.2 16C24.3 16 24.5 16.1 24.6 16.2L25.9 17.5C26.1 17.7 26.1 18.1 25.9 18.3L24.9 19.3L22.8 17.2L23.8 16.2C23.9 16.1 24 16 24.2 16ZM24.2 19.9L18.1 26H16V23.9L22.1 17.8L24.2 19.9Z"
      fill="#E1CFFF"
    />
  </svg>
);

export const defaultCurrencyIcon = (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="16" cy="16" r="16" fill="#312E45" />
    <path
      d="M22.6218 10.8734C20.9578 10.0375 18.7546 9.59998 16.2625 9.59998C13.7703 9.59998 11.5671 10.0375 9.90308 10.8734C8.23901 11.7094 7.19995 12.975 7.19995 14.2875V18.0375C7.19995 19.35 8.18433 20.5922 9.90308 21.4515C11.6218 22.3109 13.7703 22.725 16.2625 22.725C18.7546 22.725 20.9578 22.2875 22.6218 21.4515C24.2859 20.6156 25.325 19.35 25.325 18.0375V14.2875C25.325 12.975 24.3406 11.7328 22.6218 10.8734ZM10.7468 12.5453C12.1296 11.8578 14.0906 11.475 16.2625 11.475C18.4343 11.475 20.3953 11.8578 21.7781 12.5453C22.8093 13.0609 23.45 13.7328 23.45 14.2875C23.45 14.8422 22.8093 15.514 21.7781 16.0297C20.3953 16.7172 18.4343 17.1 16.2625 17.1C14.0906 17.1 12.1296 16.7172 10.7468 16.0297C9.71558 15.514 9.07495 14.8422 9.07495 14.2875C9.07495 13.7328 9.71558 13.0609 10.7468 12.5453ZM20.325 20.3343C19.3048 20.614 18.2567 20.7791 17.2 20.8265V18.9515C18.2533 18.9118 19.3 18.7679 20.325 18.5219V20.3343ZM12.2 18.5219C13.2249 18.7679 14.2717 18.9118 15.325 18.9515V20.8265C14.2682 20.7791 13.2201 20.614 12.2 20.3343V18.5219ZM9.07495 18.0375V17.2172C9.33958 17.3974 9.61627 17.5592 9.90308 17.7015L10.325 17.8969V19.5453C9.5437 19.0687 9.07495 18.514 9.07495 18.0375ZM22.2 19.5453V17.8969L22.6218 17.7015C22.9086 17.5592 23.1853 17.3974 23.45 17.2172V18.0375C23.45 18.514 22.9812 19.0687 22.2 19.5453Z"
      fill="#E1CFFF"
    />
  </svg>
);

export const NotificationLinkIcon = (
  <svg
    style={{ display: 'inline' }}
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="15" cy="15" r="15" fill="white" fillOpacity="0.9" />
    <path
      d="M16 14L21 9M21 9H17.6667M21 9V12.3333M21 16.3333V19.6667C21 20.0203 20.8595 20.3594 20.6095 20.6095C20.3594 20.8595 20.0203 21 19.6667 21H10.3333C9.97971 21 9.64057 20.8595 9.39052 20.6095C9.14048 20.3594 9 20.0203 9 19.6667V10.3333C9 9.97971 9.14048 9.64057 9.39052 9.39052C9.64057 9.14048 9.97971 9 10.3333 9H13.6667"
      stroke="#312E45"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TwitterIcon = (
  <svg
    width="17"
    height="14"
    viewBox="0 0 17 14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.34803 13.813C11.7615 13.813 15.2704 8.49818 15.2704 3.89059C15.2704 3.74117 15.2671 3.58844 15.2605 3.43902C15.9431 2.94539 16.5321 2.33395 17 1.63344C16.3643 1.91628 15.6893 2.101 14.9982 2.18129C15.7259 1.74508 16.2708 1.05981 16.5318 0.25252C15.8472 0.658247 15.0985 0.944452 14.3179 1.09887C13.7918 0.539958 13.0964 0.169893 12.3389 0.0458883C11.5815 -0.0781163 10.8043 0.0508462 10.1276 0.412837C9.45079 0.774828 8.91211 1.34969 8.59481 2.04853C8.27751 2.74738 8.19926 3.53129 8.37217 4.27906C6.98593 4.2095 5.62979 3.84939 4.39165 3.22209C3.15352 2.59478 2.06103 1.71429 1.18502 0.637677C0.739783 1.40532 0.60354 2.31368 0.80398 3.17817C1.00442 4.04265 1.5265 4.79838 2.26412 5.29176C1.71036 5.27418 1.16873 5.12508 0.683984 4.8568V4.89996C0.683488 5.70554 0.961986 6.48643 1.47214 7.1099C1.98229 7.73336 2.6926 8.16092 3.48234 8.31988C2.96937 8.46023 2.43099 8.48068 1.90885 8.37965C2.1317 9.07245 2.56528 9.6784 3.14909 10.1129C3.73289 10.5474 4.43779 10.7889 5.16541 10.8035C3.93013 11.7738 2.40421 12.3001 0.833398 12.2976C0.554828 12.2972 0.276533 12.2801 0 12.2465C1.59577 13.2703 3.45208 13.814 5.34803 13.813Z"
      fill="#312E45"
      className="transition ease-in-out duration-300 group-hover:fill-fire_orange-200"
    />
  </svg>
);
